export const ESTIMATE_DISCLAIMER_TEXT = 'Preliminary estimate — subject to change once full data is available.';
export const ESTIMATE_DISCLAIMER_SHORT = 'Preliminary estimate';
